/* eslint @typescript-eslint/no-unused-vars: off */
import SystemConst from '@/shared/system-const';
import { defineComponent, reactive, SetupContext, ref } from '@vue/composition-api';
import CommonFunction from '@/shared/common-function';                                      // 共通関数定義
import HttpStatus from 'http-status-codes';                                                 // HTTPステータスコード取得用
import CommonMessageDialog from '@/components/common/common-message-dialog.component.vue';  // メッセージダイアログコンポーネント

// リアクティブな変数の型定義
export type reactiveData = {
    isDownloadDialog: boolean;      // ローダー表示切り替え（true: 表示）
    downloadDialogTitle: string;    // ローダーのタイトルメッセージ
    bulkFileSize: string;           // 一括登録ファイルのファイルサイズ
};

/**
 * 年度更新：人事異動データ変換ファイルダウンロードコンポーネント
 * ファイル取得画面を表示する
 */
export default defineComponent({
    components: { CommonMessageDialog },
    setup(props, ctx: SetupContext) {
        const stepper = <number>3;                                         // ステッパーの3段階目
        const bulkFileName = SystemConst.PERSONNEL_CHANGE_BULK_FILE_NAME;  // 一括登録ファイルのファイル名
        const state: reactiveData = reactive<reactiveData>({
            isDownloadDialog: false,
            downloadDialogTitle: SystemConst.FISCAL_YEAR_UPDATE_FILE_DOWNLOAD_DIALOG_TITLE.LOADING, 
            bulkFileSize: SystemConst.FISCAL_YEAR_UPDATE_FILE_DOWNLOAD_FILE_SIZE_INIT
        });
        const commonRef = ref<any>(null);                                  // メッセージダイアログ

        /**
         * created
         */
        created();
        async function created() {
            // titleIcon変更
            ctx.root.$store.commit('setTitleIcon', 'mdi-file-upload-outline');

            // mainTitle変更
            ctx.root.$store.commit('setMainTitle', '人事異動データ変換');

            // ファイルサイズを取得する
            await getFileSize();
        }

        /**
         * 一括登録ファイルのファイルサイズをback側から取得する
         */
        async function getFileSize() {
            // ローダーを表示する
            state.isDownloadDialog = true;

            // ファイル情報取得処理のAPIを実行する
            const response = await ctx.root.$store.dispatch('personnelChange/getBulkFileSize');

            if (response.status !== HttpStatus.OK) {
                // ローダーを非表示にする
                state.isDownloadDialog = false;

                // HTTPステータスコードが404の場合、
                // エラーメッセージを表示してファイル選択画面へ遷移する。
                if (response.status === HttpStatus.NOT_FOUND) {
                    // 404エラーのみダイアログを表示する
                    commonRef.value.displayErrorMessageTransitionDialog(response, '/fiscal-year-update/personnel-change/upload');
                } else {
                    // HTTPステータスコードが404以外はエラーダイアログを表示、又はエラー画面へ遷移する。
                    commonRef.value.errorDisplayTransitionControl(response);
                }
                return;
            }
    
            // ステータスコードが200の場合
            // レスポンスからファイルサイズを取得し、変数に格納する
            state.bulkFileSize = response.data.bulkFileSize;

            // ローダーを非表示にする
            state.isDownloadDialog = false;
        }

        /**
         * 人事異動データ一括登録用Excelファイル群のZIP出力処理
         */
        async function outputBulkFiles() {
            // ローダーダイアログの表示をtrueにする
            state.downloadDialogTitle = SystemConst.FISCAL_YEAR_UPDATE_FILE_DOWNLOAD_DIALOG_TITLE.DOWNLOADING;
            state.isDownloadDialog = true;

            // ファイルダウンロード処理のAPIを実行する
            const response = await ctx.root.$store.dispatch('personnelChange/bulkFileDownload');

            // API通信が正常か判別する
            if (response.status !== HttpStatus.OK) {
                // テーブルがロード中のフラグをfalseに設定する。
                state.isDownloadDialog = false;

                // HTTPステータスコードが404の場合、
                // エラーメッセージを表示してファイル選択画面へ遷移する。
                if (response.status === HttpStatus.NOT_FOUND) {
                    // 404エラーのみダイアログを表示する
                    commonRef.value.displayErrorMessageTransitionDialog(response, '/fiscal-year-update/personnel-change/upload');
                } else {
                    // HTTPステータスコードが404以外はエラーダイアログを表示、又はエラー画面へ遷移する。
                    commonRef.value.errorDisplayTransitionControl(response);
                }
                return;
            }

            // ステータスコードが200の場合
            // ローダーを非表示にする
            state.isDownloadDialog = false;
        }

        return {
            stepper,
            state,
            bulkFileName,
            commonRef,
            outputBulkFiles
        };
    }
});
